import { makeSeededRand } from './barredDoors';

export const RANSACKED_CHEST_TILE = 'chest-ransacked';
export const RANSACKED_CHEST_RELIC_ID = 'old-coin';

const RANSACKED_CHEST_MIN_FLOOR = 2;
const RANSACKED_CHEST_SPAWN_CHANCE = 0.03;

export function isRansackedChestExclusiveRelic(relic) {
  return relic?.id === RANSACKED_CHEST_RELIC_ID;
}

export function maybePlaceRansackedChest(
  map,
  { spawn, floor, runSeed, spawnedRef } = {}
) {
  if (!Array.isArray(map) || !map.length || !Array.isArray(map[0])) return map;
  if ((floor ?? 1) < RANSACKED_CHEST_MIN_FLOOR) return map;
  if (spawnedRef?.current) return map;

  const rand = makeSeededRand(
    ((Number(runSeed) || 0) ^ ((Number(floor) || 1) * 0x9e3779b9) ^ 0x4f1bbcdc) >>> 0
  );

  if (rand() >= RANSACKED_CHEST_SPAWN_CHANCE) return map;

  const h = map.length;
  const w = map[0].length;
  const candidates = [];

  for (let y = 1; y < h - 1; y++) {
    for (let x = 1; x < w - 1; x++) {
      if (map[y][x] !== 'floor') continue;

      const distFromSpawn = Math.abs(x - spawn.x) + Math.abs(y - spawn.y);
      if (distFromSpawn < 4) continue;

      candidates.push({ x, y });
    }
  }

  if (!candidates.length) return map;

  const chosen = candidates[Math.floor(rand() * candidates.length)];
  if (!chosen) return map;

  const next = map.map((row) => [...row]);
  next[chosen.y][chosen.x] = RANSACKED_CHEST_TILE;

  if (spawnedRef) spawnedRef.current = true;
  return next;
}